// Libs
import { KeyboardEvent, MouseEvent } from 'react';
// App
import { CreateOrUpdateShopParam, ShopSearchResult } from 'app-shared/lib/api/shop-administration/shop';
import { SHOP_ADMIN_PAGES_URLS } from '../../shop-administration.constants';
import { PAGE_URL_AFTER_SHOP_SWITCH } from './search.constants';

const MENU_CLOSING_KEYS = ['Escape', 'Tab'];

export const buildSwitchedShopUrl = (currentPageUrl: string, shopId: number): string => {
  const pageUrl = PAGE_URL_AFTER_SHOP_SWITCH[currentPageUrl] || SHOP_ADMIN_PAGES_URLS['shop-details'];
  const switchedShopUrl = `${pageUrl}?shp_id=${shopId}`;

  return switchedShopUrl;
};

export const toShopSearchResult = (shop?: CreateOrUpdateShopParam): ShopSearchResult | null => {
  let shopSearchResult: ShopSearchResult | null = null;

  if (shop) {
    shopSearchResult = { id: shop.id, name: shop.name, slug: shop.slug };
  }

  return shopSearchResult;
};

export const addMissingShop = (shops: ShopSearchResult[], shop: ShopSearchResult | null): ShopSearchResult[] => {
  const isShopMissing = shop && !shops.some(({ id }) => id === shop.id);
  let shopsWithShop = shops;

  if (isShopMissing) {
    shopsWithShop = [shop, ...shops];
  }

  return shopsWithShop;
};

export const excludeShop = (shops: ShopSearchResult[], shopId: number): ShopSearchResult[] => {
  const otherShops = shops.filter(({ id }) => id !== shopId);

  return otherShops;
};

export const isSameShop = (shop: ShopSearchResult, otherShop: ShopSearchResult): boolean => {
  const isSame = shop.id === otherShop.id;

  return isSame;
};

export const getShopName = (shop: ShopSearchResult): string => {
  const shopName = shop.name;

  return shopName;
};

export const keepClickInsideMenu = (event: MouseEvent): void => {
  event.stopPropagation();
};

export const keepKeyInsideMenu = (event: KeyboardEvent): void => {
  const isMenuClosingKey = MENU_CLOSING_KEYS.includes(event.key);

  if (!isMenuClosingKey) {
    event.stopPropagation();
  }
};
